import { render, staticRenderFns } from "./Password-reset.vue?vue&type=template&id=67f6314c&scoped=true&"
import script from "./Password-reset.vue?vue&type=script&lang=js&"
export * from "./Password-reset.vue?vue&type=script&lang=js&"
import style0 from "./Password-reset.vue?vue&type=style&index=0&id=67f6314c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/jason/development/social-marketing-recovered/client/node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f6314c",
  null
  
)

export default component.exports